import { call, put, takeLatest } from "redux-saga/effects";
import { API_ENDPOINTS } from "../../../../util/constants";
import {
  createHeadersWithAuth,
  createQueryString,
  requestPromise
} from "../../../../util/request";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";
import {
  fetchCallHandlingSuccess,
  fetchQueueWaitTimeSuccess,
  FETCH_CALL_HANDLING,
  FETCH_QUEUE_WAIT_TIME
} from "../actions/queueMonitorActions";

function* getCallHandlingData(action) {
  let requestURL = API_ENDPOINTS.getQueueMonitoringDetails;
  const { queue_id } = { ...action.payload };
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);
  yield put(
    actions.setLoadingState({
      resource: "call_handling_today",
      loading_state: "loading",
    })
  );
  try {
    requestURL = `${requestURL}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    response["queue_id"] = queue_id;
    yield put(fetchCallHandlingSuccess(response, options.method));
    yield put(
      actions.setLoadingState({
        resource: "call_handling_today",
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}

function* getQueueWaitTimeDetials(action) {
  let requestURL = API_ENDPOINTS.getQueueWaitTimeDetails;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  yield put(
    actions.setLoadingState({
      resource: "queue_wait_time_details",
      loading_state: "loading",
    })
  );
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(fetchQueueWaitTimeSuccess(response, options.method));
    yield put(
      actions.setLoadingState({
        resource: "queue_wait_time_details",
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}

export default function* queueMonitorSaga() {
  yield takeLatest(FETCH_CALL_HANDLING, getCallHandlingData);
  yield takeLatest(FETCH_QUEUE_WAIT_TIME, getQueueWaitTimeDetials);
}
